import Validators from '../validators'

export default (store) => {
  return {
    user_access_rights: store.createEmbededEntityState({
      attrs: [
        'id',
        'typ',
        'entity'
      ],
      titles: [
        store.__('ID'),
        store.__('right'),
        store.__('entity')
      ],
      _sortField: 'valid_from',
      validators: {
        'typ': [
          Validators.isMandatory(store)
        ],
        'entity': [
          Validators.isMandatory(store)
        ]
      }
    })
  }
}
